/**
 * @generated SignedSource<<52e65a0d9f208e7ca94b2a2fa449afdc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPIListSectionHeader_taskExecutions$data = ReadonlyArray<{
  readonly numberValue: number | null;
  readonly " $fragmentType": "KPIListSectionHeader_taskExecutions";
}>;
export type KPIListSectionHeader_taskExecutions$key = ReadonlyArray<{
  readonly " $data"?: KPIListSectionHeader_taskExecutions$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIListSectionHeader_taskExecutions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "KPIListSectionHeader_taskExecutions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberValue",
      "storageKey": null
    }
  ],
  "type": "TaskExecutionNumber",
  "abstractKey": null
};

(node as any).hash = "eba160c82bebb561a5f0f5e143f90a85";

export default node;
